import styled from 'styled-components'

export const Container = styled.div`
  background-color: #fff;
  width: 500px;
  border-radius: 1rem;
  padding: 1.5rem;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
`

export const CloseButton = styled.button`
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #696969;

  &:hover {
    background-color: #F4F4F4;
  }
`

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const OptionCard = styled.div`
  display: flex;
  align-items: center;
  padding: 1.25rem;
  border: 1px solid #E5E5E5;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #0090D3;
    background-color: #f8fbfd;
  }
`

export const IconContainer = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #696969;
  flex-shrink: 0;
`

export const OptionContent = styled.div`
  flex: 1;
  margin-left: 0.75rem;
`

export const OptionTitle = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 0.25rem;
`

export const OptionDescription = styled.p`
  font-size: 13px;
  color: #696969;
  line-height: 1.4;
`

export const ChevronContainer = styled.div`
  color: #C4C4C4;
  flex-shrink: 0;
`

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
`

export const CancelButton = styled.button`
  padding: 0.7rem 1.2rem;
  font-weight: 600;
  font-size: 14px;
  border-radius: 1.5rem;
  border: 1px solid #0090D3;
  color: #0090D3;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f0f9ff;
  }
`
